import React, { memo, useEffect, useState, useCallback } from "react";
import Modal from "../../Components/Modal";
import { Close } from "@mui/icons-material";
import { Bar } from "react-chartjs-2";
import { useSelector } from "react-redux";
import { CircularProgress, IconButton } from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

const CompareChart = (props) => {
  const {
    open,
    setOpen,
    id,
    compareData,
    options,
    value,
    selectedType,
    historyRange,
  } = props;
  const [data, setData] = useState();
  const token = useSelector((state) => state.auth.Token);
  const [isLoading, setIsLoading] = useState(false);
  const [type, setType] = useState();
  const [tabTitle, setTabTitle] = useState("");
  const [range, setRange] = useState(1);

  useEffect(() => {
    options.forEach((item) => {
      if (item.gainValue === value) {
        setType(item.comparedName);
        setTabTitle(item.value);
      }
    });
  }, [value, options]);
  useEffect(() => {
    setTimeout(() => {
      setRange(1);
    }, 100);
  }, [open]);
  const dataType = useCallback(() => {
    if (selectedType.type === "program") {
      return [(range - 1) * 12, (range - 1) * 13 + 12];
    } else if (selectedType.type === "forecast") {
      return [(range - 1) * 4, (range - 1) * 5 + 4];
    }
  }, [selectedType, range]);

  useEffect(() => {
    if (
      !!selectedType &&
      !historyRange[selectedType.type].find((index) => index === range)
    ) {
      setIsLoading(true);
      historyRange[selectedType.type].push(range);
      fetch(
        `http://213.233.177.17:8022/chart/${selectedType.url}?range=${range}&dam_id=${id}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((data) => {
          console.log(data);
          data[selectedType.type].forEach((item) => {
            compareData[selectedType.type][Object.keys(item)[0]].push(
              item[Object.keys(item)[0]]
            );
            compareData[selectedType.type][Object.keys(item)[1]].push(
              item[Object.keys(item)[1]]
            );
            compareData[selectedType.type][Object.keys(item)[2]].push(
              item[Object.keys(item)[2]]
            );
            compareData[selectedType.type][Object.keys(item)[3]].push(
              item[Object.keys(item)[3]]
            );
          });
          data.real.forEach((item) => {
            compareData["real" + selectedType.type][Object.keys(item)[0]].push(
              item[Object.keys(item)[0]]
            );
            compareData["real" + selectedType.type][Object.keys(item)[1]].push(
              item[Object.keys(item)[1]]
            );
            compareData["real" + selectedType.type][Object.keys(item)[2]].push(
              item[Object.keys(item)[2]]
            );
            compareData["real" + selectedType.type][Object.keys(item)[3]].push(
              item[Object.keys(item)[3]]
            );
          });
          compareData["real" + selectedType.type].year.push(data.real[0].year);
          setData({
            data: {
              labels: !!selectedType && selectedType.labels,
              datasets: [
                {
                  type: "bar",
                  label: "مقدار واقعی",
                  data:
                    !!compareData["real" + selectedType.type][type] &&
                    compareData["real" + selectedType.type][type].slice(
                      dataType()[0],
                      dataType()[1]
                    ),
                  borderColor: "rgb(255, 99, 132)",
                  backgroundColor: "rgba(255, 99, 132, 1)",
                  hoverBackgroundColor: "rgba(255, 99, 132, 0.8)",
                  barThickness: 15,
                  borderRadius: 10,
                },
                {
                  type: "bar",
                  label:
                    !!selectedType.type === "program"
                      ? "مقدار برنامه"
                      : "مقدار پیش بینی شده",
                  data:
                    !!compareData[selectedType.type][type] &&
                    compareData[selectedType.type][type].slice(
                      dataType()[0],
                      dataType()[1]
                    ),
                  fill: false,
                  borderColor: "rgb(54, 162, 235)",
                  backgroundColor: "rgba(72,12,168,1)",
                  hoverBackgroundColor: "rgba(2,12,168, 0.8)",
                  barThickness: 15,
                  borderRadius: 10,
                },
              ],
            },
            options: {
              maintainAspectRatio: false,
              responsive: true,
              animation: true,
              normalized: true,
              spanGaps: true,
              // showLine: false,
              datasets: {
                line: {
                  pointRadius: 0, // disable for all `'line'` datasets
                },
              },
              plugins: {
                title: {
                  display: true,
                  text: selectedType.title + " " + tabTitle,
                  font: {
                    family: "IRANSansWeb",
                    size: 18,
                    lineHeight: 5,
                  },
                },
                legend: {
                  labels: {
                    // This more specific font property overrides the global property
                    font: {
                      size: 14,
                      family: "IRANSansWeb",
                    },
                  },
                  display: true,
                },
              },
              scales: {
                yAxes: {
                  title: {
                    display: true,
                    // text: 'yAxisTitle',
                    font: {
                      family: "IRANSansWeb",
                      size: 18,
                      // lineHeight: 5,
                    },
                  },
                },
                xAxes: {
                  x: {
                    type: "time",
                    time: {
                      unit: "Month",
                    },
                  },
                  title: {
                    display: true,
                    text: `سال ${
                      !!compareData["real" + selectedType.type].year[range - 1]
                        ? compareData["real" + selectedType.type].year[range - 1]
                        : ""
                    }`,
                    font: {
                      size: 15,
                      family: "IRANSansWeb",
                      lineHeight: 4,
                      weight: "bold",
                    },
                  },
                  ticks: {
                    // maxTicksLimit: 12,
                  },
                },
              },
            },
          });
          setIsLoading(false);
          console.log("compare data: ", compareData);
        })
        .catch((err) => {
          setIsLoading(false);
        });
    }
  }, [
    id,
    selectedType,
    value,
    range,
    type,
    compareData,
    dataType,
    historyRange,
    tabTitle,
    token,
  ]);

  useEffect(() => {
    if (!!selectedType && !!compareData["real" + selectedType.type][type]) {
      setData({
        data: {
          labels: !!selectedType && selectedType.labels,
          datasets: [
            {
              type: "bar",
              label: "مقدار واقعی",
              data: compareData["real" + selectedType.type][type].slice(
                dataType()[0],
                dataType()[1]
              ),
              borderColor: "rgb(255, 99, 132)",
              backgroundColor: "rgba(255, 99, 132, 1)",
              hoverBackgroundColor: "rgba(255, 99, 132, 0.8)",
              barThickness: 15,
              borderRadius: 10,
            },
            {
              type: "bar",
              label:
                !!selectedType.type === "program"
                  ? "مقدار برنامه"
                  : "مقدار پیش بینی شده",
              data: compareData[selectedType.type][type].slice(
                dataType()[0],
                dataType()[1]
              ),
              fill: false,
              borderColor: "rgb(54, 162, 235)",
              backgroundColor: "rgba(72,12,168,1)",
              hoverBackgroundColor: "rgba(2,12,168, 0.8)",
              barThickness: 15,
              borderRadius: 10,
            },
          ],
        },
        options: {
          maintainAspectRatio: false,
          responsive: true,
          animation: true,
          normalized: true,
          spanGaps: true,
          // showLine: false,
          datasets: {
            line: {
              pointRadius: 0, // disable for all `'line'` datasets
            },
          },
          plugins: {
            title: {
              display: true,
              text: selectedType.title + " " + tabTitle,
              font: {
                family: "IRANSansWeb",
                size: 18,
                lineHeight: 5,
              },
            },
            legend: {
              labels: {
                // This more specific font property overrides the global property
                font: {
                  size: 14,
                  family: "IRANSansWeb",
                },
              },
              display: true,
            },
          },
          scales: {
            yAxes: {
              title: {
                display: true,
                // text: 'yAxisTitle',
                font: {
                  family: "IRANSansWeb",
                  size: 18,
                  // lineHeight: 5,
                },
              },
            },
            xAxes: {
              x: {
                type: "time",
                time: {
                  unit: "Month",
                },
              },
              title: {
                display: true,
                text: `سال ${
                  !!compareData["real" + selectedType.type].year[range - 1]
                    ? compareData["real" + selectedType.type].year[range - 1]
                    : ""
                }`,
                font: {
                  size: 15,
                  family: "IRANSansWeb",
                  lineHeight: 4,
                  weight: "bold",
                },
              },
              ticks: {
                // maxTicksLimit: 12,
              },
            },
          },
        },
      });
    }
  }, [range, compareData, dataType, selectedType, tabTitle, type]);

  return (
    <Modal open={open}>
      <div
        style={{
          display: "flex",
          flexDirection: "row-reverse",
          height: 25,
          alignItems: "center",
        }}
      >
        <Close style={{ cursor: "pointer" }} onClick={() => setOpen(false)} />
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <IconButton
          onClick={() => {
            if (range > 1) {
              setRange((prev) => prev - 1);
            }
          }}
        >
          <ArrowBackIosNewIcon
            style={{ width: 20, color: range === 1 ? "gray" : "#000" }}
          />
        </IconButton>
        <h3 style={{ margin: "0 15px" }}>{range}</h3>
        <IconButton onClick={() => setRange((prev) => prev + 1)}>
          <ArrowForwardIosIcon style={{ width: 20, color: "#000" }} />
        </IconButton>
      </div>

      <div
        style={{
          display: "flex",
          height: 400,
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {!isLoading ? <Bar {...data} /> : <CircularProgress />}
      </div>
    </Modal>
  );
};

export default memo(CompareChart);
